/* Corazon Red cart: shared cart helpers + the display layer for the Upcart drawer. Loaded by snippets/cgc-cart-assets.liquid.
   Since 10-16 the theme has its own drawer (sections/cgc-cart-drawer.liquid + assets/cgc-drawer.js). While Upcart's
   app embed is on, everything below runs as before; once it is off, only the shared parts run: shipping protection
   (5), money + Afterpay (6) and the /cart page price fill. The drawer hands this file each new cart (API.remember).
   Read-only toward the cart: it never adds, changes or removes lines and never touches checkout. It only changes what
   the drawer SHOWS, through Upcart's documented display hook (window.upcartModifyCart gets a copy of the cart) and
   small DOM touches inside the drawer.
   1. Upcart settings, theme side only (window.upcartSettings is printed by the app embed before this deferred file
      runs, and read by Upcart's deferred bundle after it): hide "_" properties, Corazon Red colors, two empty
      html slots that this file fills (subtotal + Afterpay above the checkout button, payment icons below it).
      Upcart's admin settings are untouched, so the live theme looks exactly as before.
   2. upcartModifyCart: keeps each line's real properties (by line key) for the thumbnail and grouping, then shows:
      - the customer's design as the thumbnail (contract: docs/PERSONALIZATION_CONTRACT.md): `_preview` (https), else
        the local snapshot localStorage['cgc_preview:' + _design_id], else the plaque's legacy `_render_thumbnail` /
        localStorage['mpb_render_' + _render_id], else a per-variant image from the config (bouquet color + paper,
        plaque stands, snippets/cgc-cart-thumbs.liquid picks), else Upcart's own product image;
      - bundle add-ons (same `*_bundle_id`, `_design_id` or `_design_key`) right under their parent, indented;
      - titles in sentence case; an "Engraving: Sam & Ana" line instead of Left heart / Right heart / text-1 / text-2;
      - no property whose name starts with "_".
   3. Reserved-cart timer: a slim bar under the drawer header and under the /cart title. The deadline
      (now + 5 min, reserveMinutes) is set the first time the cart has items in this browser session and kept in
      sessionStorage, so it never resets on open / page load. At 0:00 a fresh 5-minute window starts, so the bar
      always shows while the cart has items; the cart itself is never touched. Hidden while the cart is empty. Drawer: Upcart's belowHeader html slot (re-filled after every
      re-render by the MutationObserver below); /cart: [data-cgc-reserve][data-count] printed by the section.
   4. Checkout button reads "Secure checkout" (lock icon drawn by CSS); under it the shared trust block
      (snippets/cgc-cart-trust.liquid: full-color payment icons + money-back guarantee line).
   5. Shipping protection: a row above the Subtotal (snippets/cgc-cart-protect.liquid) on the existing
      `shipping-protection` product. Off by default; ON = /cart/add.js 1, OFF = /cart/change.js 0. The line is hidden
      from the item lists and the item count, kept at quantity 1, and removed by itself when nothing else is in the
      cart. It never starts or moves the reserved-cart timer (the timer counts the other items only).
   6. Money in the slots: the subtotal mirrors the checkout button's amount (already converted by Transcy, so the two
      always agree); the Afterpay amount converts with Transcy's own rate the same way cgc-gift-builder.js does, and
      is printed as Transcy's "already converted" <tc-money> so Transcy leaves it alone. */
(function () {
  'use strict';
  if (window.__cgcCart) return;
  /* Upcart's app embed prints window.upcartSettings before this deferred file runs. Without it, the theme's own drawer
     (assets/cgc-drawer.js) is the cart: the Upcart parts below (settings patch, display hook, drawer DOM touches)
     stay off and only the shared parts run (protection, money, Afterpay, /cart page). */
  var UPCART = !!window.upcartSettings;
  var CFG = {};
  try { CFG = JSON.parse((document.getElementById('cgc-cart-config') || {}).textContent || '{}'); } catch (e) { console.warn('[cgc-cart] config', e); }
  var META = {};      /* line key -> display meta */
  var PROPS = {};     /* line key -> the line's real properties (before any hook strips "_" keys) */
  var API = window.__cgcCart = { meta: META, props: PROPS, cfg: CFG, version: 3, upcart: UPCART };

  /* ---------- 1. Upcart settings (theme side) ---------- */
  var SUM_HTML = '<div class="cgc-uc-sum" data-cgc-sum></div>';
  var TRUST_HTML = '<div class="cgc-uc-trust" data-cgc-trust></div>';
  var RESERVE_HTML = '<div class="cgc-reserve cgc-reserve--drawer" data-cgc-reserve role="timer" aria-live="off"></div>';
  (function patchSettings() {
    var S = window.upcartSettings;
    if (!S || !S.upcartSettings) { API.settingsPatched = false; return; }
    try {
      var us = S.upcartSettings, es = S.upcartEditorSettings || {};
      us.hideSingleUnderscoredProperties = true;
      /* button reads "Secure checkout" (lock icon by CSS): the price stays in the button (hidden by CSS) so Transcy
         converts it and the subtotal row above can mirror it */
      us.translations = us.translations || {};
      us.translations.checkout = 'Secure checkout{{total_price}}';
      document.documentElement.classList.add('cgc-uc-patched');
      us.htmlFields = us.htmlFields || {};
      if (!us.htmlFields.aboveFooter) us.htmlFields.aboveFooter = SUM_HTML;
      if (!us.htmlFields.belowCheckoutButton) us.htmlFields.belowCheckoutButton = TRUST_HTML;
      if (!us.htmlFields.belowHeader) us.htmlFields.belowHeader = RESERVE_HTML;
      var f = es.settingsModule && es.settingsModule.fields;
      if (f) {
        f.buttonColor = '#BE1E23'; f.buttonTextColor = '#ffffff'; f.buttonTextHoverColor = '#ffffff';
        f.cartTextColor = '#3B0D10'; f.backgroundColor = '#FBF6EF'; f.cartAccentColor = '#FBF6EF';
      }
      es.designSettingsCartSavingsTextColor = '#BE1E23';
      API.settingsPatched = !window.__upcartInitialized;
    } catch (e) { API.settingsPatched = false; }
  })();

  /* ---------- helpers ---------- */
  function str(v) { return v == null ? '' : String(v); }
  function isHttps(v) { return /^https:\/\//i.test(str(v).trim()); }
  function esc(s) { return str(s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function lsGet(k) { try { return window.localStorage.getItem(k); } catch (e) { return null; } }
  function dataImg(v) { return v && /^data:image\//.test(v) ? v : null; }

  /* sentence case for product titles: keep the first word, proper names, codes (A4, USA) and anything with a digit */
  var KEEP = (CFG.keepWords || ['Corazon', 'Netflix', "Valentine's", 'Valentine', 'I', "I'm", 'Us']).map(function (w) { return w.toLowerCase(); });
  function sentence(t) {
    var s = str(t); if (!s) return s;
    var first = true;
    return s.replace(/[A-Za-zÀ-ÿ'’0-9]+/g, function (w) {
      if (first) { first = false; return w; }
      var bare = w.replace(/’/g, "'");
      if (/\d/.test(w) || (w.length > 1 && w === w.toUpperCase())) return w;
      if (KEEP.indexOf(bare.toLowerCase()) >= 0 && /^[A-Z]/.test(w)) return w;
      return w.toLowerCase();
    });
  }
  function renameTitle(t) {
    var out = str(t);
    (CFG.rename || []).forEach(function (r) { try { out = out.replace(new RegExp(r.re), r.to); } catch (e) {} });
    return out;
  }

  /* what the customer sees under the title: no "_" keys, friendly names for the Globo option keys, file names instead
     of long URLs. Display only: the line's real properties (what Shopify and the order get) are never changed.
       rose box / bear      Left heart + Right heart, or text-2 (left) + text-1 (right)  -> "Engraving: Emma & Ross"
       infinity bracelets   large-m-engraving-1/2 -> "His bracelet: Mike · 10-08-24" (1 = left side, 2 = right side)
                            small-f-engraving-1/2 -> "Her bracelet: Katie · 10-08-24"
       bracelet set + box   text-1 = his, text-2 = hers (handle engraved-bracelet-set-w-eternal-rose-box)
       magazine             name-1 + name-2 -> "Names: Victoria & Alex"; title-1, how-many-days, celebrating-text,
                            cover-1, magazine-pics, paragraph-1 relabeled
       hand casting kit     textarea-1 -> "Plaque engraving";  necklace boxes  engraving-initials -> "Initials" */
  var BRACELET_TEXT = /^engraved-bracelet-set-w-eternal-rose-box$/;
  var LABELS = { 'textarea-1': 'Plaque engraving', 'title-1': 'Title', 'how-many-days': 'Days together',
    'celebrating-text': 'Celebrating', 'cover-1': 'Cover photo', 'magazine-pics': 'Photos', 'paragraph-1': 'Message',
    'engraving-initials': 'Initials' };
  function joinVals(a, sep) { return a.map(function (v) { return str(v).trim(); }).filter(Boolean).join(sep); }
  function displayProps(p, handle) {
    p = p || {};
    var bset = BRACELET_TEXT.test(str(handle));
    var L = p['Left heart'], R = p['Right heart'];
    var groups = {
      Engraving: { keys: bset ? ['Left heart', 'Right heart'] : ['Left heart', 'Right heart', 'text-1', 'text-2'],
        val: joinVals([L, R], ' & ') || (bset ? '' : joinVals([p['text-2'], p['text-1']], ' & ')) },   /* text-2 = left, text-1 = right */
      'His bracelet': { keys: ['large-m-engraving-1', 'large-m-engraving-2'].concat(bset ? ['text-1'] : []),
        val: joinVals([p['large-m-engraving-1'], p['large-m-engraving-2']], ' · ') || (bset ? joinVals([p['text-1']], '') : '') },
      'Her bracelet': { keys: ['small-f-engraving-1', 'small-f-engraving-2'].concat(bset ? ['text-2'] : []),
        val: joinVals([p['small-f-engraving-1'], p['small-f-engraving-2']], ' · ') || (bset ? joinVals([p['text-2']], '') : '') },
      Names: { keys: ['name-1', 'name-2'], val: joinVals([p['name-1'], p['name-2']], ' & ') }
    };
    var owner = {};
    Object.keys(groups).forEach(function (g) { groups[g].keys.forEach(function (k) { owner[k.toLowerCase()] = g; }); });
    var out = {};
    Object.keys(p).forEach(function (k) {
      if (k.charAt(0) === '_' || /^card message$/i.test(k) || /^print file$/i.test(k)) return;   /* print link stays on the order only; Love Cards are handwritten: never show an old card message */
      var v = str(p[k]).trim(); if (!v) return;
      var g = owner[k.toLowerCase()];
      if (g) { if (groups[g].val && !out[g]) out[g] = groups[g].val; return; }
      if (/^https?:\/\//i.test(v)) {
        var name = ''; try { name = decodeURIComponent(v.split('?')[0].split('/').pop() || ''); } catch (e) { name = ''; }
        v = name ? (name.length > 26 ? name.slice(0, 12) + '…' + name.slice(-11) : name) : 'Added ✓';
      }
      out[LABELS[k.toLowerCase()] || k] = v;
    });
    return out;
  }

  /* every key that can tie add-ons to a parent: any `_..._bundle_id` (never Upcart's own `_bundle_id`), `_design_id`,
     `_design_key` (the plaque builder's stand line), `_parent_design_id` (contract) */
  function linkKeys(p) {
    p = p || {};
    var out = [];
    Object.keys(p).forEach(function (k) {
      if (k.charAt(0) === '_' && /_bundle_id$/i.test(k) && !/^_?bundle_id$/i.test(k) && str(p[k])) out.push(k + '=' + p[k]);
    });
    ['_design_id', '_parent_design_id', '_design_key'].forEach(function (k) { if (str(p[k])) out.push('design=' + p[k]); });
    return out;
  }
  function groupOf(p) { var k = linkKeys(p); return k.length ? k[0] : null; }
  function looksLikeParent(p) {
    p = p || {};
    if (p._bundle_role === 'parent') return 2;
    if (p._bundle_role === 'addon') return -1;
    return (p._preview || p._render || p._render_id || p._render_thumbnail) ? 1 : 0;
  }

  /* thumbnail for a line: https URL (set on the line itself) or a local data URL (swapped in the DOM) */
  function imageFor(it, p) {
    var o = { url: null, local: null, fit: null, custom: false };
    if (isHttps(p._preview)) { o.url = str(p._preview).trim(); o.custom = true; return o; }
    var store = window.CGCPreviewStore;
    if (p._design_id) {
      o.local = dataImg(store ? store.getLocalPreview(p._design_id) : lsGet('cgc_preview:' + p._design_id));
      if (o.local) { o.custom = true; return o; }
    }
    if (isHttps(p._render_thumbnail)) { o.url = str(p._render_thumbnail).trim(); o.custom = true; return o; }
    if (p._render_id) { o.local = dataImg(lsGet('mpb_render_' + p._render_id)); if (o.local) { o.custom = true; return o; } }
    var rule = (CFG.images || {})[it.handle];
    if (rule) {
      var opts = {}; (it.options_with_values || []).forEach(function (x) { opts[str(x.name).toLowerCase()] = str(x.value).toLowerCase(); });
      if (rule.src) { o.url = rule.src; o.fit = rule.fit || null; }
      else if (rule.map && rule.by) {
        var k = rule.by.map(function (n) { return opts[str(n).toLowerCase()] || ''; }).join('/');
        if (rule.map[k]) { o.url = rule.map[k]; o.fit = rule.fit || null; }
      } else if (rule.pattern && CFG.assetTpl) {
        /* snippets/cgc-cart-thumbs.liquid: {Option name} = picked value, last word ("Marble Black" -> black) */
        var miss = false;
        var f = rule.pattern.replace(/\{([^}]+)\}/g, function (m, n) {
          var v = opts[n.toLowerCase()]; if (!v) { miss = true; return m; } return v.split(' ').pop();
        });
        var dot = f.lastIndexOf('.');   /* assetTpl = .../__cgc___240x.jpg (Shopify's sized asset URL) */
        if (!miss && dot > 0) o.url = CFG.assetTpl.replace('__cgc__', f.slice(0, dot)).replace(/\.jpg$/, f.slice(dot));
      }
      if (o.url && o.url.indexOf('//') === 0) o.url = 'https:' + o.url;
    }
    return o;
  }

  /* ---------- 2. Upcart display hook ---------- */
  function transform(cart) {
    if (!cart || !cart.items) return cart;
    var pq = protQty(cart);
    var items = cart.items.filter(function (it) { return !isProt(it); }).map(function (it) {
      var p = PROPS[it.key] || it.properties || {};
      return { it: it, p: p, g: null };
    });
    /* lines that share any link key form one group (union-find over the keys) */
    var owner = {}, up = items.map(function (x, i) { return i; });
    function find(i) { while (up[i] !== i) { up[i] = up[up[i]]; i = up[i]; } return i; }
    items.forEach(function (x, i) {
      linkKeys(x.p).forEach(function (k) { if (owner[k] == null) owner[k] = i; else up[find(i)] = find(owner[k]); });
    });
    items.forEach(function (x, i) { if (linkKeys(x.p).length) x.g = 'g' + find(i); });
    /* groups with 2+ lines: parent = explicit role, else the personalized line, else the one added first
       (a single /cart/add.js call lists items newest first, so the first-added line is the LAST in cart order) */
    var groups = {};
    items.forEach(function (x, i) { if (x.g) (groups[x.g] = groups[x.g] || []).push(i); });
    Object.keys(groups).forEach(function (g) {
      var idx = groups[g];
      if (idx.length < 2) { idx.forEach(function (i) { items[i].g = null; }); return; }
      var best = idx[idx.length - 1], score = looksLikeParent(items[best].p);
      idx.slice().reverse().forEach(function (i) { var s = looksLikeParent(items[i].p); if (s > score) { best = i; score = s; } });
      groups[g] = { parent: best, kids: idx.filter(function (i) { return i !== best; }).reverse() };
    });
    var order = [], done = {};
    items.forEach(function (x, i) {
      if (done[i]) return;
      if (!x.g) { order.push(i); done[i] = 1; return; }
      var G = groups[x.g];
      order.push(G.parent); done[G.parent] = 1;
      G.kids.forEach(function (k) { order.push(k); done[k] = 1; });
    });

    var out = [];
    order.forEach(function (i, pos) {
      var x = items[i], it = x.it, p = x.p;
      var role = !x.g ? 'single' : (groups[x.g].parent === i ? 'parent' : 'child');
      var kids = x.g ? groups[x.g].kids : [];
      var img = imageFor(it, p);
      var title = sentence(renameTitle(it.product_title || it.title));
      var copy = {};
      for (var k in it) if (Object.prototype.hasOwnProperty.call(it, k)) copy[k] = it[k];
      copy.properties = displayProps(p, it.handle);
      copy.product_title = title;
      if (it.options_with_values) copy.options_with_values = it.options_with_values.map(function (o) { return { name: sentence(o.name), value: o.value }; });
      if (!img.url && img.local && CFG.blank) img.url = CFG.blank;   /* Upcart then draws an <img> whose src we swap */
      if (img.url) {
        copy.image = img.url;
        copy.featured_image = Object.assign({}, it.featured_image || {}, { url: img.url, alt: it.featured_image && it.featured_image.alt || title });
      }
      META[it.key] = { role: role, group: x.g, local: img.local, fit: img.fit, custom: img.custom,
        lastChild: role === 'child' && kids[kids.length - 1] === i, title: title, pos: pos };
      out.push(copy);
    });
    var res = {};
    for (var c in cart) if (Object.prototype.hasOwnProperty.call(cart, c)) res[c] = cart[c];
    res.items = out;
    if (pq && typeof cart.item_count === 'number') res.item_count = Math.max(0, cart.item_count - pq);
    return res;
  }

  (function installHook() {
    if (!UPCART) return;
    var prev = window.upcartModifyCart;
    window.__cgbUpcartHook = true;   /* the builders' own "hide _ properties" hook is covered by this one */
    window.upcartModifyCart = function (cart) {
      try { (cart && cart.items || []).forEach(function (it) { PROPS[it.key] = Object.assign({}, it.properties || {}); }); } catch (e) {}
      if (cart && typeof cart.total_price === 'number') { lastCart = cart; protCheck(cart); }
      var c = cart;
      try { if (typeof prev === 'function') { var r = prev(cart); if (r && typeof r === 'object') c = r; } } catch (e) {}
      try { c = transform(c); } catch (e) { console.warn('[cgc-cart] display hook', e); }
      schedule();
      return c;
    };
  })();

  /* ---------- 2b. shipping protection ---------- */
  var PROT = CFG.protection && CFG.protection.variant ? CFG.protection : null;
  var protPending = null, protBusy = false, protFixAt = 0;
  function isProt(it) { return !!(PROT && it && +it.variant_id === +PROT.variant); }
  function protQty(c) { var q = 0; (c && c.items || []).forEach(function (it) { if (isProt(it)) q += +it.quantity || 0; }); return q; }
  function protLine(c) { var l = null; (c && c.items || []).forEach(function (it) { if (!l && isProt(it)) l = it; }); return l; }
  function protOn() { return protPending != null ? protPending : protQty(lastCart) > 0; }
  function onCartPage(el) { return !!(el && el.closest && el.closest('[data-cgc-cartpage]')); }
  function cartPost(path, body) {
    return fetch(((window.Shopify && Shopify.routes && Shopify.routes.root) || '/') + path, { method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { if (!r.ok) throw new Error(path + ' ' + r.status); return r.json(); });
  }
  function protSet(on, fromPage) {
    if (!PROT || protBusy) return Promise.resolve();
    protBusy = true; protPending = !!on; schedule(); markBusy(true);
    var line = protLine(lastCart);
    var req = on ? (protQty(lastCart) ? Promise.resolve() : cartPost('cart/add.js', { items: [{ id: +PROT.variant, quantity: 1 }] }))
                 : cartPost('cart/change.js', { id: line ? line.key : String(PROT.variant), quantity: 0 });
    return req.catch(function (e) { console.warn('[cgc-cart] protection', e); }).then(function () {
      if (fromPage) { location.reload(); return; }
      return fetch(((window.Shopify && Shopify.routes && Shopify.routes.root) || '/') + 'cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); }).then(function (c) { lastCart = c; }).catch(function () {})
        .then(function () { protBusy = false; protPending = null; markBusy(false); redraw(); schedule(); });
    });
  }
  /* re-render whichever drawer is in use after a protection change */
  function redraw() {
    if (window.CGCCart && window.CGCCart.refresh) { try { window.CGCCart.refresh(); return; } catch (e) {} }
    if (UPCART && window.upcartRefreshCart) window.upcartRefreshCart();
  }
  function markBusy(on) { [].forEach.call(document.querySelectorAll('[data-cgc-protect-toggle]'), function (b) { tog(b, 'is-busy', on); }); }
  /* keep it at 1, and take it out when it is the only thing left (a few seconds apart at most, never in a loop) */
  function protCheck(c) {
    if (!PROT || protBusy || !c || !c.items) return;
    var q = protQty(c), rest = (c.items || []).filter(function (it) { return !isProt(it); }).length;
    if (!q || (q === 1 && rest) || Date.now() - protFixAt < 4000) return;
    protFixAt = Date.now();
    var line = protLine(c), page = document.querySelector('[data-cgc-cartpage]');
    protBusy = true;
    cartPost('cart/change.js', { id: line.key, quantity: rest ? 1 : 0 }).catch(function (e) { console.warn('[cgc-cart] protection fix', e); })
      .then(function () {
        protBusy = false;
        if (page) { location.reload(); return; }
        redraw();
      });
  }
  function protRowHTML() {
    var t = document.getElementById('cgc-cart-protect');
    if (!PROT || !t) return '';
    return t.innerHTML.replace('__CHECKED__', protOn() ? 'true' : 'false').replace('__BUSY__', protBusy ? ' is-busy' : '')
      .replace('__PRICE__', moneyHTML(+PROT.price || 0, true));
  }
  document.addEventListener('click', function (e) {
    var b = e.target && e.target.closest && e.target.closest('[data-cgc-protect-toggle]');
    if (!b) return;
    e.preventDefault(); e.stopPropagation();
    if (protBusy) return;
    var on = b.getAttribute('aria-checked') !== 'true';
    b.setAttribute('aria-checked', on ? 'true' : 'false');
    protSet(on, onCartPage(b));
  }, true);

  /* ---------- 3. reserved-cart timer ---------- */
  var RES_KEY = 'cgc_cart_reserved_until';
  var RES_MS = (+CFG.reserveMinutes || 10) * 60000;
  var RES_TEXT = str(CFG.reserveText || 'Your cart is reserved for {time}');
  var CLOCK = '<svg class="cgc-reserve__icon" viewBox="0 0 16 16" aria-hidden="true"><circle cx="8" cy="8" r="6.25" fill="none" stroke="currentColor" stroke-width="1.5"/><path d="M8 4.6V8l2.3 1.5" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  function ssGet(k) { try { return window.sessionStorage.getItem(k); } catch (e) { return null; } }
  function ssSet(k, v) { try { window.sessionStorage.setItem(k, v); } catch (e) {} }
  function cartCount() {
    var c = lastCart || (UPCART && window.upcartPreloadedCart);
    if (c && typeof c.item_count === 'number') return Math.max(0, c.item_count - protQty(c));
    if (c && c.items) return c.items.filter(function (it) { return !isProt(it); }).length;
    return null;
  }
  /* the deadline is created once per session, on the first look at a cart with items; never moved after that */
  function deadline(count) {
    var d = +ssGet(RES_KEY) || 0;
    if (!d && count > 0) { d = Date.now() + RES_MS; ssSet(RES_KEY, String(d)); }
    return d;
  }
  function mmss(ms) { var s = Math.max(0, Math.ceil(ms / 1000)), m = Math.floor(s / 60); s = s % 60; return (m < 10 ? '0' : '') + m + ':' + (s < 10 ? '0' : '') + s; }
  function reserveEls() {
    var out = [].slice.call(document.querySelectorAll('[data-cgc-reserve]'));
    var r = document.getElementById('upCart'), sh = r && r.shadowRoot;
    if (sh) out = out.concat([].slice.call(sh.querySelectorAll('[data-cgc-reserve]')));
    return out;
  }
  function paintReserve() {
    var els = reserveEls(); if (!els.length) return;
    var now = Date.now();
    els.forEach(function (el) {
      /* the theme drawer re-renders from Shopify after every change, so its own count is the current one */
      var n = el.closest('[data-cgcd-content]') ? +el.getAttribute('data-count') : cartCount();
      if (n == null && el.hasAttribute('data-count')) n = +el.getAttribute('data-count');
      var d = n ? deadline(n) : (+ssGet(RES_KEY) || 0), left = d - now;
      var on = !!(n && d && left > 0);
      if (on && !el.querySelector('[data-cgc-reserve-time]')) {
        var parts = RES_TEXT.split('{time}');
        el.innerHTML = CLOCK + '<span class="cgc-reserve__text">' + esc(parts[0]) + '<b class="cgc-reserve__time" data-cgc-reserve-time></b>' + esc(parts.slice(1).join('')) + '</span>';
      }
      if (on) { var t = el.querySelector('[data-cgc-reserve-time]'), v = mmss(left); if (t && t.textContent !== v) t.textContent = v; }
      tog(el, 'is-on', on);
    });
    /* expired (the bar should always show while the cart has items): start a fresh window */
    var dd = +ssGet(RES_KEY) || 0;
    if (dd && dd <= now) { var c2 = cartCount(); if (c2) ssSet(RES_KEY, String(now + RES_MS)); else ssSet(RES_KEY, ''); }
  }
  var resT = (UPCART || document.querySelector('[data-cgc-reserve],[data-cgcd]')) ? setInterval(paintReserve, 1000) : null;
  API.reserve = { key: RES_KEY, paint: paintReserve };

  /* ---------- 6. money for the slots (Transcy-safe) ---------- */
  var CUR = CFG.currency || (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD';
  function display() {
    var code = CUR, rate = 1;
    try {
      var t = window._transcy, v = t && t.variants, info = v && v.currencyActiveInfo;
      var want = v && ((v.currencyTargetInfo && v.currencyTargetInfo.code) || v.currencyCurrent);
      if (want && want !== CUR && info && info.code === CUR && info.detail && info.detail.convert && info.detail.convert[want]) { code = want; rate = +info.detail.convert[want]; }
    } catch (e) {}
    return { code: code, rate: rate };
  }
  function moneyHTML(cents, decimals) {
    var d = display(), n = cents / 100 * d.rate, s;
    try { s = new Intl.NumberFormat('en-US', { style: 'currency', currency: d.code, minimumFractionDigits: decimals ? 2 : 0, maximumFractionDigits: decimals ? 2 : 0 }).format(n); }
    catch (e) { s = '$' + n.toFixed(decimals ? 2 : 0); }
    if (d.code === 'CAD') s = s.replace('CA$', 'C$');
    if (d.code === CUR) return '<span class="cgc-uc-money">' + s + '</span>';
    /* zero-width space after the symbol so Transcy's /\$\s?\d+/ can't convert it a second time */
    return '<tc-money translate="no" class="cgc-uc-money money-done--' + d.code + '">' + s.replace(/([^\d\s])(\d)/, '$1​$2') + '</tc-money>';
  }

  /* ---------- 7. drawer DOM: thumbnails, grouping classes, slots ---------- */
  var root = null, mo = null, queued = false, lastCart = null;
  function schedule() { if (queued) return; queued = true; (window.requestAnimationFrame || setTimeout)(function () { queued = false; enhance(); }); }
  function tog(el, cls, on) { if (el && el.classList.contains(cls) !== !!on) el.classList.toggle(cls, !!on); }

  function thumb(el, m) {
    var wrap = el.querySelector('.upcart-product-image-wrapper');
    if (!wrap) return;
    tog(wrap, 'cgc-uc-fit', m.fit === 'contain');
    tog(wrap, 'cgc-uc-custom', !!m.custom);
    if (!m.local) return;
    var img = wrap.querySelector('img');
    if (!img) {   /* product without a photo: Upcart draws a placeholder icon; put the design in its place */
      var a = wrap.querySelector('a') || wrap;
      img = a.querySelector('img.cgc-uc-img');
      if (!img) { img = document.createElement('img'); img.className = 'cgc-uc-img'; img.alt = m.title || ''; a.appendChild(img); }
      tog(wrap, 'cgc-uc-noimg', true);
    }
    if (img.getAttribute('src') !== m.local) { img.removeAttribute('srcset'); img.setAttribute('src', m.local); }
  }

  function totalCents() {
    var c = lastCart || (UPCART && window.upcartPreloadedCart); return c && typeof c.total_price === 'number' ? c.total_price : null;
  }

  /* one installment, in the currency the subtotal is shown in: split the shown subtotal itself (so 4 x amount = the
     subtotal the customer sees); fall back to converting the cart total */
  function installment(shown, cents, n) {
    var d = display();
    var m = /^([^\d]*)([\d.,\s\u00a0\u202f]+)(.*)$/.exec(str(shown).replace(/\u200b/g, '').trim());
    if (m && d.code !== CUR) {
      var num = m[2].replace(/[\s\u00a0\u202f]/g, ''), lm = /([.,])(\d{1,2})$/.exec(num), dec = lm ? lm[1] : '';
      var val = parseFloat((dec ? num.slice(0, -lm[0].length) : num).replace(/[.,]/g, '') + (dec ? '.' + lm[2] : ''));
      if (isFinite(val) && val > 0) {
        var part = (Math.round(val / n * 100) / 100).toFixed(2);
        if (dec === ',') part = part.replace('.', ',');
        return '<tc-money translate="no" class="cgc-uc-money money-done--' + d.code + '">' + esc(m[1]) + '\u200b' + part + esc(m[3]) + '</tc-money>';
      }
    }
    return moneyHTML(Math.round(cents / n), true);
  }

  function fillSum(scope) {
    var slot = scope.querySelector('[data-cgc-sum]');
    if (!slot) {   /* settings patch missed (Upcart started first): put the slot in the footer ourselves */
      var foot = scope.querySelector('.upcart-footer');
      if (!foot) return;
      slot = document.createElement('div'); slot.className = 'cgc-uc-sum cgc-uc-sum--injected'; slot.setAttribute('data-cgc-sum', '');
      foot.insertBefore(slot, foot.firstChild);
    }
    var btnMoney = scope.querySelector('.upcart-checkout-button .transcy-money, .upcart-checkout-button [class*="money"]');
    var cents = totalCents();
    var amount = btnMoney ? btnMoney.textContent.replace(/\s+/g, ' ').trim() : '';
    var sub = amount ? '<span class="cgc-uc-money">' + esc(amount).replace(/([^\d\s])(\d)/, '$1​$2') + '</span>' : (cents != null ? moneyHTML(cents) : '');
    /* the store format drops cents ($119.49 -> "$119"); in the store currency show the exact amount when it has cents
       (shipping protection is $3.49). Converted currencies keep mirroring Transcy's own number. */
    if (cents != null && cents % 100 && display().code === CUR) sub = moneyHTML(cents, true);
    var n = +CFG.installments || 0, ap = '';
    if (n > 1 && cents != null && cents >= (+CFG.installmentsMin || 0) && cents <= (+CFG.installmentsMax || 1e12)) {
      ap = '<p class="cgc-uc-ap">' + esc(CFG.installmentsText || 'or {n} interest-free payments of {amount} with').replace('{n}', n)
        .replace('{amount}', '<b>' + installment(amount, cents, n) + '</b>') + ' Afterpay</p>';
    }
    var html = sub ? protRowHTML() + '<div class="cgc-uc-subrow"><span>' + esc(CFG.subtotalLabel || 'Subtotal') + '</span><strong>' + sub + '</strong></div>' + ap : '';
    if (slot.__cgc !== html) { slot.innerHTML = html; slot.__cgc = html; }
  }

  /* payment icons + guarantee line: a copy of snippets/cgc-cart-trust.liquid (same block as on /cart) */
  function fillTrust(scope) {
    var slot = scope.querySelector('[data-cgc-trust]');
    if (!slot || slot.__cgc) return;
    var t = document.getElementById('cgc-cart-trust');
    if (!t) return;
    slot.innerHTML = t.innerHTML;
    slot.__cgc = 1;
  }

  /* reserve slot: if the settings patch missed (Upcart started first), put it right under the header ourselves */
  function ensureReserve(scope) {
    var all = scope.querySelectorAll('[data-cgc-reserve]');
    if (all.length > 1) [].forEach.call(scope.querySelectorAll('.cgc-reserve--injected'), function (e) { e.remove(); });   /* Upcart's own slot won */
    if (all.length || API.settingsPatched) return;   /* patched: Upcart renders the slot itself (only once the cart has items) */
    var head = scope.querySelector('.upcart-header');
    if (!head || !head.parentNode) return;
    var d = document.createElement('div'); d.innerHTML = RESERVE_HTML;
    var el = d.firstChild; el.classList.add('cgc-reserve--injected');
    head.parentNode.insertBefore(el, head.nextSibling);
  }

  /* /cart: the row's price in the shown currency, the same number as the drawer row (Liquid prints the store price;
     Transcy's own rounding would show C$5 where the drawer says C$4.96) */
  function fillPagePrice() {
    if (!PROT) return;
    [].forEach.call(document.querySelectorAll('[data-cgc-cartpage] .cgc-protect__price, [data-cgcd] .cgc-protect__price'), function (el) {
      var h = moneyHTML(+PROT.price || 0, true);
      if (el.__cgc !== h) { el.innerHTML = h; el.__cgc = h; }
    });
  }

  function enhance() {
    fillPagePrice();
    if (!UPCART) return;
    root = root && root.isConnected ? root : document.getElementById('upCart');
    if (!root) return;
    var scope = root.shadowRoot || root;
    if (mo && !mo.__on) observe(scope);
    var lines = scope.querySelectorAll('.upcart-product-item');
    [].forEach.call(lines, function (el) {
      var m = META[el.id];
      if (!m) return;
      if (!m.custom && PROPS[el.id]) {   /* the snapshot may have been saved after the hook ran */
        var o = imageFor({}, PROPS[el.id]);
        if (o.local) { m.local = o.local; m.custom = true; }
      }
      tog(el, 'cgc-uc-child', m.role === 'child');
      tog(el, 'cgc-uc-parent', m.role === 'parent');
      tog(el, 'cgc-uc-lastchild', !!m.lastChild);
      thumb(el, m);
    });
    tog(root, 'cgc-uc-empty', lines.length === 0);
    /* never offer the protection product as an upsell */
    [].forEach.call(scope.querySelectorAll('.upcart-upsell-item-card, .upcart-upsell-item'), function (c) {
      var h = c.querySelector('.upcart-upsell-item-title');
      if (h && /shipping protection/i.test(h.textContent)) tog(c, 'cgc-uc-hide', true);
    });
    /* upsell titles in sentence case too (text node only; Upcart re-sets it if the product changes) */
    [].forEach.call(scope.querySelectorAll('.upcart-upsell-item-title'), function (h) {
      var t = h.firstChild;
      if (t && t.nodeType === 3 && h.childNodes.length === 1) { var s = sentence(t.data); if (s !== t.data) t.data = s; }
    });
    fillSum(scope); fillTrust(scope); ensureReserve(scope); paintReserve();
  }

  function observe(scope) {
    mo.observe(scope, { childList: true, subtree: true, characterData: true });
    mo.__on = true;
  }
  if (UPCART && window.MutationObserver) {
    mo = new MutationObserver(function (list) {
      for (var i = 0; i < list.length; i++) {
        var t = list[i].target;
        if (t && t.closest && t.closest('[data-cgc-sum],[data-cgc-trust],[data-cgc-reserve]')) continue;
        schedule(); return;
      }
    });
    /* wait for Upcart to mount #upCart */
    var boot = new MutationObserver(function () { if (document.getElementById('upCart')) { boot.disconnect(); schedule(); } });
    boot.observe(document.documentElement, { childList: true, subtree: true });
    setTimeout(function () { boot.disconnect(); }, 30000);
  }
  function remember(c) { if (c && typeof c.total_price === 'number') { lastCart = c; protCheck(c); schedule(); } }
  /* first paint before Upcart's hook has run: read the total once (read-only) */
  function refreshTotal() {
    fetch((window.Shopify && Shopify.routes && Shopify.routes.root || '/') + 'cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); }).then(function (c) { if (!lastCart) remember(c); else protCheck(c); }).catch(function () {});
  }
  document.addEventListener('cgc:preview-saved', schedule);
  window.addEventListener('storage', function (e) { if (e.key && /^(cgc_preview:|mpb_render_)/.test(e.key)) schedule(); });
  /* Transcy can switch the display currency late: re-fill the slots for ~20 s */
  var tc = 0, tcT = setInterval(function () { schedule(); if (++tc > 40) clearInterval(tcT); }, 500);
  API.refresh = schedule; API.protection = { set: protSet, on: protOn, cfg: PROT }; API.remember = remember;
  API.sentence = sentence; API.displayProps = displayProps; API.groupOf = groupOf; API.installment = installment;
  /* native drawer: it hands over the cart the page printed (no request); /cart and Upcart read it once */
  function cgcBoot() { if (UPCART || document.querySelector('[data-cgc-cartpage]')) refreshTotal(); if (resT) paintReserve(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', cgcBoot); else cgcBoot();
})();
